import React, { useState, useEffect } from 'react';
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { BiBarChartAlt2 } from 'react-icons/bi';
import { commafy,uiLabel } from 'Utils';
import { useHistory } from 'react-router-dom';
import { chartSeriesColor } from 'Utils/styleTokens';
import PerfectScrollbar from 'react-perfect-scrollbar';
import DiscoveryTooltip from 'DiscoveryTooltip';
import { BsShieldCheck } from 'react-icons/bs';
import { GoFileZip } from 'react-icons/go';
import {
  archiveInnerPath,
  archiveOuterName,
  isArchivePath,
} from 'Utils/archivePath';

// Last `/` or `\` separated segment of a path, or the input unchanged when it
// has no separator. Used to derive the displayed file name for file-source
// drill-downs where the URL `:table` segment is the full relative path.
const basename = (p) => {
  if (!p) return '';
  const slash = Math.max(p.lastIndexOf('/'), p.lastIndexOf('\\'));
  return slash >= 0 && slash < p.length - 1 ? p.slice(slash + 1) : p;
};

// Heuristic: a relational table name has no path separators and no archive
// boundary, so anything containing one of those is a file source's path.
const looksLikeFilePath = (name) =>
  typeof name === 'string' &&
  (name.indexOf('/') >= 0 || name.indexOf('\\') >= 0 || isArchivePath(name));

const TableEntityBarchart = (props) => {
  const [data, setData] = useState([]);
  const [maxCount, setMaxCount] = useState(0);
  const [tableMeta, setTableMeta] = useState({});
  const history = useHistory();
  
  useEffect(() => {
    if (props.rowsSampled != null && props.rowsSampled !== '') {
      setTableMeta({ rows_count: props.rowsSampled });
    } else {
      setTableMeta({});
    }
  }, [props.rowsSampled]);

  useEffect(() => {
    const filteredOverview = props.filteredOverview;
    const keys = Object.keys(filteredOverview);
    let dataValue = [];
    let maxCountValue = 0;

    for (let i = 0; i < keys.length; i++) {
      maxCountValue = Math.max(maxCountValue, filteredOverview[keys[i]]);

      let item = {
        x: filteredOverview[keys[i]],
        label: keys[i]
      };
      dataValue.push(item);
    }
    dataValue.sort((a, b) => b.x - a.x);

    const colorValues = keys.map((_, i) => chartSeriesColor(i));


    for (let i = 0; i < dataValue.length; i++) {
        dataValue[i].y = i;
        dataValue[i].color = colorValues[i];    
    }

    setMaxCount(maxCountValue);
    setData(dataValue);


  }, [props.filteredOverview]);

  const getBarChart = (count, itemColor, type, index, entity) => {
    let width = `${Math.floor((count / maxCount) * 100)}%`;
    let color = entity === 'ALL' || type === entity ? itemColor : '#D9DDE3';
    let textColor = entity === 'ALL' || type === entity ? '#212630' : '#8A92A0';

    return (
      <div key={type || index} className="mb-3 w-100">
        <div className="mb-0 text-left table-entity-text" style={{ fontSize: '13px' }}>
          Found <span style={{ fontWeight: '500' }}>{commafy(count)}</span> instances of {' '}
          <DiscoveryTooltip text={`Filter by ${uiLabel(type)}`} placement='top'>
            <span>
              <Link 
                to={`/results/${props.searchid}/${type}/${props.table}`}
              >
                {uiLabel(type)}
              </Link> 
            </span>
          </DiscoveryTooltip>
          {' '} data
        </div>
        <div
          onClick={() => history.push(`/results/${props.searchid}/${type}/${props.table}`)}
          key={index}
          className="scale-up-hor-left mb-2 custom-barchart pointer table-entity-barchart"
          style={{
            color: textColor,
            backgroundColor: color,
            width: width
          }}
        />
      </div>
    )
  }
  const tableName = props.table || '';
  const isFile = looksLikeFilePath(tableName);
  const isArchive = isArchivePath(tableName);
  // For archive paths, the displayed "file name" is the leaf inside the archive
  // (basename of the inner path); fall back to the on-disk archive name when
  // the source is the bare archive root.
  const displayName = isArchive
    ? (basename(archiveInnerPath(tableName)) || archiveOuterName(tableName))
    : (isFile ? basename(tableName) : tableName);
  // Don't repeat the path under the title when it's identical to the leaf.
  const showFullPath = isFile && tableName !== displayName;

  return (
    <Card
      style={{
        maxHeight: '400px'
      }}
      className="shadow-sm widget-card"
    >
    <div className="widget-header text-left pb-0 ">
      <div>
        <BiBarChartAlt2 className="mr-2 widget-header-icon" />{' '}
        <span style={{ fontSize: '16px' }}>
          {isFile ? 'File: ' : 'Table: '}{displayName}
        </span>
      </div>
      {showFullPath && (
        <div
          style={{
            fontSize: '12px',
            color: '#5C6473',
            marginTop: '2px',
            paddingLeft: '24px',
            display: 'flex',
            alignItems: 'flex-start',
            gap: 4,
            wordBreak: 'break-all',
          }}
          title={tableName}
        >
          {isArchive && (
            <GoFileZip
              aria-label='Inside archive'
              style={{ flexShrink: 0, marginTop: 2 }}
            />
          )}
          <span style={{ fontFamily: 'monospace' }}>{tableName}</span>
        </div>
      )}
    </div>


      <Card.Body className='pt-0'>
        <PerfectScrollbar>
          <div style={{ height: '330px', textTransform: 'capitalize'}}>
            <div className="mb-4  ml-0 text-left" style={{fontSize: "12px",minHeight:'18px'}}>
             {tableMeta && tableMeta.rows_count ? (`${tableMeta.rows_count} rows sampled`) : (null)}
            </div>
            { data.length === 0 ? (
              <div>
                <div className='auto pt-5'>
                  <div className='mb-4'><BsShieldCheck size='50px' /></div>
                  <div>No significant findings</div>
                </div>
              </div>
            ) : (null)}
            { data.map((item, i) =>
            (props.entity === 'ALL' || item.label === props.entity) ? 
              getBarChart(item.x, item.color, item.label, i, props.entity) : null)
            }
          </div>
        </PerfectScrollbar>
      </Card.Body>
    </Card>
  );
}

export default TableEntityBarchart;